import { useQueryParams } from 'src/hooks/useQueryParams';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { batch } from 'react-redux';
import log from 'src/utils/logger';
import { useAppDispatch } from 'src/store';
import { updateUserTier } from 'src/store/slices/sessionSlice';
import { UserTierStatus } from 'src/types';
import { usersApi, UsersTags } from 'src/store/services';
import { UserTier } from 'src/types/models/UserTier';
import { convertTierName } from 'src/utils/user';
import { useSubscriptionInfo } from 'src/hooks/paymentHooks';

export const useUpgradeDowngradeParams = () => {
  const { searchParams, removeAllSearchParams } = useQueryParams();
  const { isLegacyPlan } = useSubscriptionInfo();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!!searchParams.operation_type) {
      log.debug('useUpgradeDowngradeParams->searchParams', searchParams);
      const tierName = searchParams.to_tier
        ? convertTierName(searchParams.to_tier)
        : searchParams.to_tier;
      if (searchParams.status === 'rejected') {
        toast.error(
          'Consent approval is needed in the PayPal popup. Please try again and provide your consent.',
        );
        removeAllSearchParams();
        return;
      }
      if (searchParams.operation_type === 'no_change') {
        if (
          searchParams.status === 'scheduled' ||
          searchParams.status === 'successful'
        ) {
          toast.success('Subscription updated');
        } else {
          toast.error('Subscription update failed');
        }
        removeAllSearchParams();
        return;
      }
      if (searchParams.operation_type === 'upgrade') {
        if (searchParams.status === 'successful') {
          toast(
            isLegacyPlan
              ? 'Payment processing in progress'
              : `Upgrade to ${tierName} successful`,
          );
          batch(() => {
            // todo needs not to_tier, but plan_kind - temporary hidden till change it on BE side
            // const modalType: WelcomeUpsellModalTypeV2 | null =
            //   searchParams.to_tier === NinjaSubscriptionPlan.ULTRA
            //     ? 'max-10-welcome-modal'
            //     : searchParams.to_tier === NinjaSubscriptionPlan.PRO
            //       ? 'pro-10-welcome-modal'
            //       : null;
            // if (modalType) {
            //   dispatch(setWelcomeUpsellModalType(modalType));
            //   dispatch(toggleWelcomeModal(true));
            // }

            dispatch(
              updateUserTier({
                new_tier: searchParams.to_tier as UserTier,
                new_tier_status: UserTierStatus.OK,
              }),
            );
            dispatch(usersApi.util.invalidateTags([UsersTags.Users]));
          });
        } else if (searchParams.status === 'scheduled') {
          toast('Account upgrade started');
        } else {
          toast.error(`Upgrade to ${tierName} failed`);
        }
        removeAllSearchParams();
        return;
      }
      if (searchParams.operation_type === 'downgrade') {
        if (searchParams.status === 'scheduled') {
          toast('Account downgrade started');
        } else {
          toast.error('Account downgrade failed');
        }
        removeAllSearchParams();
        return;
      }
      removeAllSearchParams();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.status, searchParams.to_tier, searchParams.operation_type]);
};
